import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  router = inject(Router);

  confirm() {
    this.router.navigate([environment.urls.confirmation], { queryParams: { responsecode: 'ok' } });
  }

  kioskConfirm(orderid: string) {
    this.router.navigate([environment.urls.kiosk.confirmation], { queryParams: { orderid } });
  }

  post(accepturl: string) {
    window.location.href = accepturl;
  }
}
